module.exports = __webpack_public_path__ + "static/media/flavours-east.4cea8ffa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/flavours-east.jpg
// module id = 1633
// module chunks = 0